import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Text Decoration Icons
// =============================================================================

export function DecorationNone(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "DecorationNone",
    viewBox: "0 0 24 24",
    path: (
      <line
        x1="5"
        y1="12"
        x2="19"
        y2="12"
        stroke="currentColor"
        strokeWidth="2"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function Underline(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "Underline",
    viewBox: "0 0 24 24",
    path: (
      <>
        <path
          d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="4"
          y1="21"
          x2="20"
          y2="21"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function Strikethrough(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "Strikethrough",
    viewBox: "0 0 24 24",
    path: (
      <>
        <path
          d="M17.3 4.9c-2.3-.6-4.4-1-6.2-.9-2.7 0-5.3.7-5.3 3.6 0 1.5 1.8 3.3 7.2 3.8"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <path
          d="M21 12H3"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <path
          d="M8.5 15.5c0 2.4 2.9 3.6 6.2 3.6 3.3 0 5.6-1.2 5.6-3.8 0-1.5-1-2.9-2.5-3.3"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
